export enum ProfileStatus {
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING_TERMS_AND_CONDITIONS = 'PENDING_TERMS_AND_CONDITIONS'
}
